import { SipPlanMode } from '../../../api/types'
import { EventNames } from '../../../../../../../types/misc.types'
import { trackEvent } from '../../../../../../../utils/appBridge'
import { PlansSipListEventIds, PlansSipListScreenByPlanMode } from '../../../../analytics/plansEvents'
import { isSipPlansFetchFailed, isSipPlansHeaderLoading, useSipPlansContext } from '../../SipPlansProvider'
import { isSipYourPlanListFullyEmpty } from '../../../../utils/sip/planListUtils'
import {
  DEFAULT_SIP_ACTION_FILTERS,
  ListSipActionFilters,
  SIP_PLANS_ACTION_FILTERS_CLASS_NAME
} from './ListSipActionFilters'

export function SipPlansActionFilters() {
  const { planMode, actionFilter, handleActionFilterChange, plansOverview, derivedPlans, plansQuery } =
    useSipPlansContext()

  if (planMode !== SipPlanMode.YOUR_PLAN) {
    return null
  }

  const isHeaderLoading = isSipPlansHeaderLoading(
    SipPlanMode.YOUR_PLAN,
    plansOverview != null,
    plansQuery
  )
  const isPlansEmpty =
    !isHeaderLoading && isSipYourPlanListFullyEmpty(derivedPlans?.yourPlanCategories)
  const isPlansFetchFailed = isSipPlansFetchFailed(SipPlanMode.YOUR_PLAN, plansQuery)

  if (plansOverview?.isPlanSubscriptionEligible !== true) {
    const yourPlanCategories = derivedPlans?.yourPlanCategories ?? []
    const hasLockedListContent = yourPlanCategories.some((category) => {
      const stopCount = category?.stopRecommendations?.length ?? 0
      const startCount = category?.startRecommendations?.length ?? 0
      const increaseCount = category?.increaseRecommendations?.length ?? 0
      const decreaseCount = category?.decreaseRecommendations?.length ?? 0
      return stopCount + startCount + increaseCount + decreaseCount > 0
    })
    if (!hasLockedListContent) {
      return null
    }
  }

  if (isPlansEmpty || isPlansFetchFailed) {
    return null
  }

  return (
    <div className={SIP_PLANS_ACTION_FILTERS_CLASS_NAME} data-sip-plans-action-filters>
      <ListSipActionFilters
        availableFilters={DEFAULT_SIP_ACTION_FILTERS}
        activeFilter={actionFilter}
        onFilterChange={(nextFilter) => {
          trackEvent({
            eventName: EventNames.UserClicked,
            payload: {
              ScreenName: PlansSipListScreenByPlanMode?.[planMode],
              eventId: PlansSipListEventIds.ActionFilter,
              buttonLabel: nextFilter
            }
          })
          handleActionFilterChange(nextFilter)
        }}
      />
    </div>
  )
}
